module.exports = __webpack_public_path__ + "img/fruit-brambles-190x100.5b42b0e1.jpg";